<qf-info-confirm-dialog [template]="dialogTemplate" [customBodyNgTemplate]="errorModalBody" [dialogSettings]="dialogSettings" [errorTraceId]="traceId"></qf-info-confirm-dialog>

<ng-template #errorModalBody>
    <div class="modal-body py-0">
        <h6>{{ errorTitle | translate }}</h6>
        <p class="small">{{ errorMessage | translate }}</p>
    </div>
    <div *ngIf="currEnvironment.enableHttpErrorDetails && stackTrace" class="modal-body bg-body border-bottom border-top py-2 mt-3 small">
        <div class="gap-2 hstack">
            <span class="me-auto">{{ 'Error details' | translate }}</span>
            <i class="fa-duotone cursor-pointer"
               [ngClass]="{
                          'fa-arrow-up-right-and-arrow-down-left-from-center': isErrorDetailCollapsed,
                          'fa-arrow-down-left-and-arrow-up-right-to-center': !isErrorDetailCollapsed}"
               (click)="collapse.toggle()"
               [ngbTooltip]="((isErrorDetailCollapsed ? 'Expand' : 'Collapse') + ' detail') | translate">
            </i>
            <i *ngIf="!isErrorDetailCollapsed"
               class="fa-duotone fa-copy cursor-pointer link-secondary ms-3"
               (click)="copyErrorMsgToClipboard()"
               [ngbTooltip]="'Copy to clipboard' | translate">
            </i>
        </div>
        <hr *ngIf="!isErrorDetailCollapsed" class="bg-secondary my-2">
        <samp #collapse="ngbCollapse" [(ngbCollapse)]="isErrorDetailCollapsed" class="small">
            <strong>{{ errorTitle | translate }}</strong>
            <pre class="mb-0 qf-scrollbar">{{ stackTrace }}</pre>
        </samp>
    </div>
</ng-template>
